import { BRAND_LOGO, BRAND_NAME } from "@/lib/brand";

/** Reusable Rent Lupi logo + wordmark. */
export default function BrandMark({ size = "md", showWordmark = true, className = "" }) {
  const sizes = {
    sm: { box: "w-7 h-7", text: "text-base" },
    md: { box: "w-9 h-9", text: "text-lg" },
    lg: { box: "w-12 h-12", text: "text-xl" },
    xl: { box: "w-20 h-20", text: "text-3xl" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <div className={`${s.box} rounded-full overflow-hidden ring-1 ring-[#FFD700]/40 bg-white shrink-0`}>
        <img src={BRAND_LOGO} alt={BRAND_NAME} className="w-full h-full object-cover" />
      </div>
      {showWordmark && (
        <span className={`font-display font-bold ${s.text} tracking-tight`}>{BRAND_NAME}</span>
      )}
    </div>
  );
}
